import builder from '../builder';
import RotateForward from '../../streamline-icons/bold/rotate-forward.svg';

export default builder('IconRotateForwardBold', RotateForward);
